<div [ngClass]="{ progress1: percentage }" class="progress">
  <div class="barOverflow">
    <div
      class="bar"
      [ngStyle]="{
        'border-bottom-color': colorVal,
        'border-right-color': colorVal,
        transform: rotationVal,
      }"
    ></div>
    <span class="centered DSA_h5Header number GreyDark">{{ match }}</span>
  </div>
  <div [ngClass]="{ 'match-text1': percentage }" class="match-text infoTxt">{{ matchText }}</div>
</div>
